import { TFunction } from 'i18next';

export enum VideoType {
  NoType = '',
  AdditionalRepair = 'Additional Repair',
  RepairInquiry = 'Repair inquiry',
  RegularService = 'Regular service',
  ServiceReminder = 'Service reminder',
  QuoteRequest = 'Quote request',
}

export enum VideoTypeSales {
  NoType = '',
  Marketing = 'Marketing',
  Prospecting = 'Prospecting',
  RespondToInquiry = 'Respond to Inquiry',
  ThanksForYourBusiness = 'Thanks For Your Business',
}

export const getVideoTypes = (isSalesUser: boolean, t: TFunction) => {
  const types = Object.values(isSalesUser ? VideoTypeSales : VideoType).filter(
    (videoType: string) => !!videoType
  );
  return types.map((videoType: string) => {
    return {
      value: videoType,
      label: t(videoType),
    };
  });
};
